// Copyright © 2021 Move Closer
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { SizeMap } from '../../_composables';
import { useInputControl } from '../../_abstract';
import { BootstrapFormError } from '../FormError';
import { BootstrapIcon } from '../Icon';
import { bootstrapInputProps } from './Input.hooks';
import { bootstrapInputSizeRegistry } from './Input.config';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const BootstrapInput = defineComponent({
    name: 'BootstrapInput',
    components: { FormError: BootstrapFormError, Icon: BootstrapIcon },
    props: bootstrapInputProps,
    emits: ['blur', 'focus'],
    setup(props, ctx) {
        const { size } = toRefs(props);
        const { sizeClass, validationClass, value: _model } = useInputControl(props, ctx, bootstrapInputSizeRegistry);
        /**
         * Determines the size of the prepended icon
         */
        const iconSize = computed(() => size.value === SizeMap.Medium ? SizeMap.Small : SizeMap.Medium);
        return { iconSize, _model, sizeClass, validationClass };
    },
    template: `
    <div class="form-input" :class="[sizeClass, icon ? '--with-icon' : '']">

      <!-- Main <input> element -->
      <input v-model="_model" v-bind="{ autocomplete, disabled, name, readonly, required, type }" :id="$id()"
             class="form-input__control form-control" :class="validationClass" @focus="() => $emit('focus')" @blur="() => $emit('blur')"
             :placeholder="placeholder || ' '" :aria-label="label" >

      <!-- Icon -->
      <Icon v-if="icon" :name="icon" :size="iconSize" class="form-input__icon" />

      <!-- Label -->
      <label :for="$id()" class="form-input__label form-label">
        {{ label }}<span v-if="required" class="form-label__asterisk">&nbsp;*</span>
      </label>

      <!-- Validation errors -->
      <FormError v-for="error in errors" :key="$id(error)">
        {{ error }}
      </FormError>

    </div>
  `
});
